import { NotificationCenter } from "../../portal/notifications/NotificationCenter";
import { useSupportSurface } from "../SupportSurfaceContext";

/** Legacy support adapter over the portal-owned notification center. */
export function NotificationBell() {
  const { routes } = useSupportSurface();
  return (
    <NotificationCenter supportBase={routes.list === "/" ? "" : routes.list} />
  );
}
